import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import excelFillService from "./excelFillService";

const getErrorMessage = (error) => {
  return (
    error?.response?.data?.message || error?.message || "Er ging iets fout."
  );
};

export const previewExcelFill = createAsyncThunk(
  "excelFill/preview",
  async ({ schoolYearId, file, sheetName, headerRow }, thunkAPI) => {
    try {
      return await excelFillService.previewExcelFill({
        schoolYearId,
        file,
        sheetName,
        headerRow,
      });
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  },
);

export const checkExcelFill = createAsyncThunk(
  "excelFill/check",
  async (payload, thunkAPI) => {
    try {
      return await excelFillService.checkExcelFill(payload);
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  },
);

export const generateExcelFill = createAsyncThunk(
  "excelFill/generate",
  async (payload, thunkAPI) => {
    try {
      return await excelFillService.generateExcelFill(payload);
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  },
);

const initialState = {
  preview: null,
  checkResult: null,
  generatedFile: null,

  isPreviewLoading: false,
  isChecking: false,
  isGenerating: false,

  error: null,
};

const excelFillSlice = createSlice({
  name: "excelFill",
  initialState,

  reducers: {
    resetExcelFill: () => initialState,

    clearExcelFillError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(previewExcelFill.pending, (state) => {
        state.isPreviewLoading = true;
        state.error = null;
      })

      .addCase(previewExcelFill.fulfilled, (state, action) => {
        state.isPreviewLoading = false;
        state.preview = action.payload?.data || null;
      })

      .addCase(previewExcelFill.rejected, (state, action) => {
        state.isPreviewLoading = false;
        state.error = action.payload || "Preview mislukt.";
      })

      .addCase(checkExcelFill.pending, (state) => {
        state.isChecking = true;
        state.error = null;
        state.checkResult = null;
      })

      .addCase(checkExcelFill.fulfilled, (state, action) => {
        state.isChecking = false;
        state.checkResult = action.payload?.data || null;
      })

      .addCase(checkExcelFill.rejected, (state, action) => {
        state.isChecking = false;
        state.error = action.payload || "Controle mislukt.";
      })

      .addCase(generateExcelFill.pending, (state) => {
        state.isGenerating = true;
        state.error = null;
      })

      .addCase(generateExcelFill.fulfilled, (state, action) => {
        state.isGenerating = false;
        state.generatedFile = action.payload;
      })

      .addCase(generateExcelFill.rejected, (state, action) => {
        state.isGenerating = false;
        state.error = action.payload || "Excel genereren mislukt.";
      });
  },
});

export const { resetExcelFill, clearExcelFillError } = excelFillSlice.actions;

export default excelFillSlice.reducer;
